import { render } from "./AccordionWrapper.vue?vue&type=template&id=d20ea8a0"
import script from "./AccordionWrapper.vue?vue&type=script&lang=js"
export * from "./AccordionWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__